
import LeagueImg from './LeagueImg.vue';
/**
 * A small tag indicating a monetary change.
 *
 * The color is green if the gain was positive, and red otherwise.
 */
export default {
  name: 'PortfolioRankTag',
  components: {
    LeagueImg,
  },
  props: {
    /**
     * The portfolio's ranking.
     */
    rank: {
      type: Number,
      required: true,
    },
    isPublic: {
      type: Boolean,
      default: true,
    },
    inUnrankedState: {
      type: Boolean,
      default: false,
    },
    showLeagueAvatar: {
      type: Boolean,
      default: false,
    },
    leagueAvatarUri: {
      type: String,
      default: null,
    },
    /**
     * The size of the rank tag in pixels.
     * Defaults corresponds to full-screen portfolio cards
     */
    size: {
      type: Number,
      default: 8,
    },
    fontSize: {
      type: Number,
      default: 3,
    },
    //added for controling the size of league image
    leagueImgSize: {
      type: Number,
      default: 20,
    },
  },

  computed: {
    computedClass() {
      const res = this.sizeClass + this.fontClass;
      switch (this.rank) {
        case 1:
          return (
            res +
            'bg-league-rank-bg-first text-league-rank-text-first border-2 border-league-rank-border-first'
          );
        case 2:
          return (
            res +
            'bg-league-rank-bg-second text-league-rank-text-second border-2 border-league-rank-border-second'
          );
        case 3:
          return (
            res +
            'bg-league-rank-bg-third text-league-rank-text-third border-2 border-league-rank-border-third'
          );
        default:
          return res + 'bg-neutral-4 text-neutral-10';
      }
    },
    sizeClass() {
      return this.rank < 100
        ? ' w-' + this.size + ' h-' + this.size + ' '
        : ' px-1 py-1 ';
    },
    fontClass() {
      return (
        ' text-fs-' + (this.rank < 100 ? this.fontSize : '1') + ' text-fw-4 '
      );
    },
    positionClass() {
      if (this.leagueImgSize >= 32) {
        return 'top-3 left-2 translate-x-1/2 translate-y-1/2';
      }

      if (this.rank < 100) return 'top-3 left-0';
      if (this.rank < 1000) return 'top-4 -left-1';
      return 'top-4 -left-2';
    },
  },
};
